<template>
  <p class="ad-support-link">For additional help, please contact <a href="#" class="awp-link">ADURO Support.</a></p>
</template>

<script>
  export default {
    name: 'c-authorization-support-link'
  };
</script>



// WEBPACK FOOTER //
// AuthorizationSupportLink.vue?b525d084